import httpClient from "../axiosBase/axiosHandler";

export const getProfitAndLossReport = (data) => {
  return httpClient.post("metrics/export-profit-lost-report/", data);
};

export const getGoals = (queries = "") => {
  return httpClient.get(`/goals/revenue/${queries}`);
};

export const createGoals = (data) => {
  return httpClient.post("/goals/revenue/", data);
};

export const updateGoals = ({ id, data }) => {
  return httpClient.patch(`/goals/revenue/${id}/`, data);
};

export const getGoalsDetails = ({ id }) => {
  return httpClient.get(`/goals/revenue/${id}/`);
};

export const deleteGoals = ({ id }) => {
  return httpClient.delete(`/goals/revenue/${id}/`);
};
